import { createApi } from '@reduxjs/toolkit/query/react';
import type { SearchResult } from './models/searchResult.model';
import BaseQuery from './base.api';

export interface GeneralSearchParams {
    accountId: number;
    accountTypeCode: string;
    sourceId: number;
    searchTerm: string;
}

export const generalSearchApi = createApi({
    reducerPath: 'generalSearchApi',
    baseQuery: BaseQuery('/v1/generalSearch'),
    tagTypes: ['GeneralSearch'],
    endpoints: (builder) => ({
        generalSearch: builder.query<SearchResult[], GeneralSearchParams>({
            query: ({ accountId, accountTypeCode, sourceId, searchTerm }) =>
                `?accountId=${accountId}&accountTypeCode=${accountTypeCode}&sourceId=${sourceId}&searchTerm=${encodeURIComponent(searchTerm)}`,
        }),
    }),
});

export const { useGeneralSearchQuery, useLazyGeneralSearchQuery } = generalSearchApi;
